import React, {
  ComponentType,
  useState
} from 'react'
import {
  Button,
  Form,
  Header,
  Message,
  Segment
} from 'semantic-ui-react'
// Local
import { LoginLogo } from '../common/brandingUtils'
import isValidEmail from '../common/emailUtils'
import If from '../common/if'
import { shouldRenderReskin2025 } from '../../constant'
import ReveleerLogoStacked from '../logos/ReveleerLogoStacked'
import ReveleerButton from '../common/ReveleerButton'
import ReveleerCoachingBox from '../ReveleerCoachingBox'

const SafeSegment = Segment as unknown as ComponentType<any>
const SafeHeader = Header as unknown as ComponentType<any>
const SafeForm = Form as unknown as ComponentType<any>

/**
 * Provides a Forgot Password form
 * @param id An ID attribute prefix used to identify component elements
 * @param onSubmit Login form submit callback function
 */

type NameAndValue = {
  name: string
  value: string | null
}

type Props = {
  errorMessage: string
  id: string
  onSubmit: (email: string) => void
}

function ForgotPasswordForm(
  props: Props
): JSX.Element {
  const {
    errorMessage,
    id,
    onSubmit: onSubmitProp
  } = props
  const [
    emailState,
    setEmailState
  ] = useState<string>('')
  const [
    isNoSubmitState,
    setNoSubmitState
  ] = useState<boolean>(true)

  const onSubmit = () => {
    if (emailState.length > 0) {
      onSubmitProp(emailState)
    }
  }

  const onChange = (
    e: any,
    value: NameAndValue
  ) => {
    if (value != null && value.name != null && value.value != null) {
      setEmailState(value.value)
      if (value.name === 'email' && typeof (value.value) === 'string') {
        const email = String(value.value)
        const isValid = isValidEmail(email)
        setNoSubmitState(!isValid)
      }
    }
  }

  return (
    <SafeSegment>
      <SafeForm error={ errorMessage != null }>
        <SafeHeader
          as="h2"
          textAlign="center"
        >
          <Header.Content>
            <If isTrue={ !shouldRenderReskin2025 }>
              { LoginLogo() }
            </If>
            <If isTrue={ shouldRenderReskin2025 }>
              <ReveleerLogoStacked />
            </If>
          </Header.Content>
        </SafeHeader>
        <If isTrue={ !shouldRenderReskin2025 }>
          <SafeHeader
            as="h3"
            textAlign="center"
          >
            <Header.Content>
              Password Assistance
            </Header.Content>
          </SafeHeader>
        </If>
        <If isTrue={ shouldRenderReskin2025 }>
          <h3 className="reveleer text-align-center">
            Password Assistance
          </h3>
        </If>
        <div
          className={
            shouldRenderReskin2025
              ? 'forgot-passwd-txt text-align-center'
              : 'forgot-passwd-txt'
          }
        >
          <span>
            Enter the email address associated with your Curation account.
          </span>
        </div>
        <If isTrue={ !!errorMessage }>
          <If isTrue={ !shouldRenderReskin2025 }>
            <Message
              error={ true }
              content={ errorMessage }
            />
          </If>
          <If isTrue={ shouldRenderReskin2025 }>
            <ReveleerCoachingBox
              coachingBoxType="error"
              isShowing
              message={
                <p>
                  { errorMessage }
                </p>
              }
            />
          </If>
        </If>
        <Form.Input
          id={ `${id}-forgot-passwd-email` }
          label={
            shouldRenderReskin2025
              ? ''
              : 'Email:'
          }
          onChange={ onChange }
          name="email"
          placeholder={
            shouldRenderReskin2025
              ? 'Email'
              : ''
          }
        />
        <If isTrue={ !shouldRenderReskin2025 }>
          <Button
            onClick={ onSubmit }
            disabled={ isNoSubmitState }
            id={ `${id}-forgot-passwd-submit` }
            color="blue"
            type="submit"
          >
            Submit
          </Button>
        </If>
        <If isTrue={ shouldRenderReskin2025 }>
          <ReveleerButton
            buttonLabel="Submit"
            buttonSize="large"
            buttonType="primary"
            id={ `${id}-forgot-passwd-submit` }
            isDisabled={ emailState === '' }
            onClick={ onSubmit }
            type="submit"
          />
        </If>
      </SafeForm>
    </SafeSegment>
  )
}

export default ForgotPasswordForm
